var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items > 0)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"navigation-link item logged mr-2 no-underline",attrs:{"href":"/products?tab=review"}},[_c('span',{staticClass:"link-text"},[_vm._v("Review")]),_vm._v(" "),_c('span',{staticClass:"numb"},[_vm._v(_vm._s(_vm.items))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }